import ShopScreen from '../shop/ShopScreen';

/** /product — Print Shop with selected gallery art. */
function Product() {
  return <ShopScreen />;
}

export default Product;
